import React, { useEffect } from 'react'
import { useState } from 'react';
import { useSelector } from 'react-redux';

function DenialReason() {
    const ClaimData = useSelector((state) => state.claimDetailSlice);
    const [denyAmount, setDenyAmount] = useState('');

    useEffect(() => {
        ClaimData.claimInfo.length > 0 && ClaimData.claimInfo.map((data) => {
            if (data.Disposition == 'Deny') {
                setDenyAmount(typeof data?.AmountSubmitted != 'undefined' ? data?.AmountSubmitted : '--')
            }
        })
    }, [ClaimData])

    let deniedAmount = 0

    return (
        <div>    <div class="intro-y box mt-lg-5">
            <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
                <h2 class="fw-medium fs-base me-auto">
                    Denial Reasons
                </h2>
            </div>
            {/* {typeof (ClaimData?.DenialReason) == "string" && <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
                    <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                        <div class="d-flex flex-column  mt-3">
                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 mb-3 px-2"> Reasons : </div>{ClaimData.DenialReason}
                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Denied Amount :  <div class="text-gray-600 px-2">{ClaimData?.claimInfo?.length == 0 ? "--" : ClaimData?.claimInfo[0]?.AmountSubmitted}</div></div>
                        </div>
                    </div>
                </div>}
                {ClaimData?.DenialReason?.length > 0 && Array.isArray(ClaimData.DenialReason)? <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
                    <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                        <div class="d-flex flex-column  mt-3">
                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 mb-3 px-2"> Reasons : </div></div>{ClaimData?.DenialReason?.map((data) => {
                                return <React.Fragment><p class="text-gray-600 px-2">{data?.DenialReason || data} </p><br /></React.Fragment>
                            })}
                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Denied Amount :  <div class="text-gray-600 px-2">{ClaimData?.claimInfo?.length == 0 ? "--" : ClaimData?.claimInfo[0]?.AmountSubmitted}</div></div>
                        </div>
                    </div> : "No reasons is there"}
                    {ClaimData?.claimInfo?.length > 0 && Array.isArray(ClaimData.claimInfo) && <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
                    <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                        <div class="d-flex flex-column  mt-3">
                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 mb-3 px-2"> Reasons : </div></div>{ClaimData?.claimInfo?.map((lineItem) => {
                                deniedAmount += lineItem.AmountSubmitted;
                                return <React.Fragment><p class="text-gray-600 px-2">{lineItem?.ReasonCode || ""} </p><br /></React.Fragment>
                            })}
                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Denied Amount :  <div class="text-gray-600 px-2">{deniedAmount == 0 ? '--' : `$${Number(deniedAmount).toFixed(2)}`}</div></div>
                        </div>
                    </div> } */}
           
            {denyAmount === "" && (ClaimData?.DenialReason == "--" || ClaimData?.DenialReason == "" )? <div className='p-5 mt-3'>No reasons Found</div> :
                ClaimData?.DenialReason != "--" && ClaimData?.DenialReason != ""  && typeof ClaimData?.DenialReason === "string"
                    ? (
                        <div class="d-flex flex-column flex-lg-row p-5 pb-10 mx-n5 row">
                            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                                <div class="d-flex flex-column mt-3">
                                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 mb-3 px-2"> Reasons : </div>
                                    {ClaimData.DenialReason}
                                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                                        Denied Amount :
                                        <div class="text-gray-600 px-2">
                                            {ClaimData?.claimInfo?.length === 0 ?  `$${Number(ClaimData.TotalAmountSubmitted).toFixed(2)}` : `$${Number(ClaimData?.claimInfo[0]?.AmountSubmitted).toFixed(2)}`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    : Array.isArray(ClaimData?.DenialReason) && ClaimData?.DenialReason?.length > 0
                        ? (
                            <div class="d-flex flex-column flex-lg-row p-5 pb-10 mx-n5 row">
                                <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                                    <div class="d-flex flex-column mt-3">
                                        <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 mb-3 px-2"> Reasons : </div>
                                        {ClaimData?.DenialReason?.map((data, index) => (
                                            <React.Fragment key={index}>
                                                <p class="text-gray-600 px-2">{data?.DenialReason || data}</p>
                                                <br />
                                            </React.Fragment>
                                        ))}
                                        <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                                            Denied Amount :
                                            <div class="text-gray-600 px-2">
                                                {ClaimData?.claimInfo?.length === 0 ? `$${Number(ClaimData.TotalAmountSubmitted).toFixed(2)}` : `$${Number(ClaimData?.claimInfo[0]?.AmountSubmitted).toFixed(2)}`}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : Array.isArray(ClaimData?.claimInfo) && ClaimData.claimInfo?.length > 0
                            ? (
                                <div class="d-flex flex-column flex-lg-row p-5 pb-10 mx-n5 row">
                                    <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                                        <div class="d-flex flex-column mt-3">
                                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 mb-3 px-2"> Reasons : </div>
                                            {ClaimData?.claimInfo?.map((lineItem, index) => {
                                                if (typeof lineItem.ReasonCode != 'undefined') {
                                                    deniedAmount += Number(lineItem.AmountSubmitted);
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <p class="text-gray-600 px-2">{lineItem?.ReasonCode}</p>
                                                            <br />
                                                        </React.Fragment>
                                                    );
                                                }
                                            })}
                                            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2">
                                                Denied Amount :
                                                <div class="text-gray-600 px-2">
                                                    {deniedAmount === 0 ? '$0.00' : `$${Number(deniedAmount).toFixed(2)}`}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            : <div className='p-5 mt-3'>No reasons found</div>
            }

        </div></div>
    )
}

export default DenialReason